/**
 * Identifies which embedded-partner integration a session belongs to. Kept in
 * its own file (rather than inline in AppViewCubit) so partnerConfig.ts can
 * import it without a circular dependency on AppViewCubit.tsx.
 */
export enum KnownPartnerSources {
  transcarent = "transcarent",
  personifyHealth = "personifyHealth"
}
